/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Chat_Mentions_BlurbInputs */



/**
* | output |
* | --- |
* | "Type @ to bring a file, space, or artifact from this project into the conversation. The assistant instantly gets its full content to work with." |
*
* @param {Uno_Edu_Chat_Mentions_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_chat_mentions_blurb = /** @type {((inputs?: Uno_Edu_Chat_Mentions_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Chat_Mentions_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie @ ein, um eine Datei, einen Space oder ein Artefakt aus diesem Projekt in die Konversation zu holen. Der Assistent erhält sofort den vollständigen Inhalt.")
	return /** @type {LocalizedString} */ ("Type @ to bring a file, space, or artifact from this project into the conversation. The assistant instantly gets its full content to work with.")
});